import React from "react";
import styled from "styled-components";
import { pxtoRem } from "../../lib/helper";

export const StyledCheckbox = styled.span`
  display: block;
  position: relative;
  padding-left: ${pxtoRem(22)};
  margin-bottom: ${pxtoRem(12)};
  cursor: pointer;
  font-size: ${pxtoRem(12)};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
    height: ${pxtoRem(22)};
    width: ${pxtoRem(22)};
    z-index: 1;
  }

  input:checked ~ .checkmark {
    background-color: ${(props) => props.theme.colors.APPLE_GREEN};
  }

  input:checked ~ .checkmark:after {
    display: block;
  }

  .checkmark:after {
    left: ${pxtoRem(5)};
    top: 0;
    width: ${pxtoRem(8)};
    height: ${pxtoRem(15)};
    border: solid white;
    border-width: 0 1.2px 1.2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

export const StyledCheckMark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  border: 1px solid ${(props) => props.theme.colors.DARK_GREY};
  height: ${pxtoRem(22)};
  width: ${pxtoRem(22)};
  border-radius: ${pxtoRem(2)};
  background-color: ${(props) => props.theme.colors.WHITE};
  &:after {
    content: "";
    position: absolute;
    display: none;
  }
`;

function DropdownCheckbox({ checked = false, onChange, ...props }) {
  return (
    <StyledCheckbox>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => {
          onChange(e.target.checked);
        }}
        {...props}
      />
      <StyledCheckMark className="checkmark"></StyledCheckMark>
    </StyledCheckbox>
  );
}

export default DropdownCheckbox;
